module.exports = __webpack_public_path__ + "img/G.2fa946ce.png";